import styled from "styled-components";

export const BodyContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 24px 82px 0 80px;

  @media only screen and (max-width: 1050px) {
    padding: 12px 30px 0 60px;
  }

  @media only screen and (max-width: 768px) {
    padding: 12px;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: 68px;

  @media screen and (max-width: 400px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const DescriptionContainer = styled.div`
  flex-direction: column;
  justify-content: space-evenly;
  width: 100%;
  margin-top: 56px;
`;

export const DescriptionContentWhithGroups = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  width: 90%;
`;

export const DescriptionText1 = styled.span`
  display: flex;
  flex-direction: column;
  width: 100%;
  color: ${(props) => props.theme.colors.body};
`;

export const LabelText = styled.div`
  display: flex;

  @media screen and (max-width: 400px) {
    flex-direction: column;
  }
`;

export const TableContainer = styled.div`
  display: flex;
  width: 80%;
  height: 100%;
  margin-top: 46px;
  margin-left: 134px;

  .table {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
  }

  .toggle-button {
    background: ${(props) => props.theme.colors.success};
  }

  .toggle-button-on {
    background: ${(props) => props.theme.colors.success};
  }

  .toggle-button-off {
    background: ${(props) => props.theme.colors.border};
  }

  .toggle-label {
    margin-left: 8px;
    color: ${(props) => props.theme.colors.label};
    font-weight: 700;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.75px;
  }

  .thead {
    display: flex;
    width: 100%;
  }

  .th-group {
    text-transform: capitalize;
    display: flex;
    width: 25%;
    font-weight: 700;
    font-size: 12px;
    color: ${(props) => props.theme.colors.label};
    @media screen and (max-width: 560px) {
      font-size: 8px;
    }
  }
  .th-video {
    text-transform: capitalize;
    display: flex;
    width: 38%;
    font-weight: 700;
    font-size: 12px;
    color: ${(props) => props.theme.colors.label};
    @media screen and (max-width: 560px) {
      font-size: 8px;
    }
  }

  .th-display {
    text-transform: capitalize;
    display: flex;
    width: 20%;
    font-weight: 700;
    font-size: 12px;
    color: ${(props) => props.theme.colors.label};
    @media screen and (max-width: 560px) {
      font-size: 8px;
    }
  }

  .tbody {
    display: flex;
    flex-direction: column;
  }

  .th-first {
    margin-left: -50px;
  }

  .tr-head {
    display: flex;
    width: 100%;
    justify-content: space-around;
  }

  .tr-container {
    display: flex;
    align-items: center;
    justify-content: space-around;
    border-radius: 8px;
    border: 1px solid #eff0f7;
    height: 50px;
    margin-top: 8px;
    cursor: pointer;
    background-color: white;
    z-index: 2;

    @media screen and (max-width: 560px) {
      height: 100%;
    }
  }

  .td-group {
    display: flex;
    align-items: center;
    width: 35%;
  }

  .group-title {
    margin-left: 16px;
    color: ${(props) => props.theme.colors.title};
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;

    @media only screen and (max-width: 1200px) {
      font-size: 12px;
    }

    @media screen and (max-width: 560px) {
      font-size: 10px;
    }
  }

  .td-video {
    display: flex;
    align-items: center;
    font-weight: 600;
    width: 30%;

    span {
      background-color: #f4f7ff;
      padding-left: 10px;
      padding-right: 10px;
      border-radius: 4px;
      align-self: center;
      font-size: 14px;
      line-height: 20px;
      color: ${(props) => props.theme.colors.body};

      @media only screen and (max-width: 760px) {
        font-size: 12px;
      }
    }
  }

  .td-display {
    display: flex;
    align-items: center;
    width: 20%;
  }

  @media only screen and (max-width: 1200px) {
    width: 100%;
    margin: 36px auto 16px auto;
  }
`;

export const DescriptionContentWhithoutGroups = styled.div``;

export const Description = styled.div`
  display: flex;
  flex-direction: column;
  width: 70%;
  margin-left: 30px;
`;

export const DescriptionTitle = styled.span`
  font-size: 18px;
  font-weight: 400;
  margin-bottom: 16px;
`;

export const DescriptionText = styled.span`
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 8px;
`;

export const DescriptionButtonContainer = styled.div`
  margin-top: 24px;
`;
